/* eslint-disable camelcase */
/*
 https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
*/

const formatAddonsNameToIntercomKey = addonName => addonName.replace(/ /g, '_').toLocaleLowerCase();

export const showProductTour = (productTourId) => {
    if (window?.Intercom) {
        window.Intercom('startTour', productTourId);
    }
};

export const formatAddonsToIntercom = (addons = [], subscriptionAddonsIds) => addons
    .reduce((acc, cur) => ({
        ...acc,
        [formatAddonsNameToIntercomKey(cur.name)]: subscriptionAddonsIds.includes(cur.id),
    }), {});

export const updateIntercomSettings = ({
    userInfo = {},
    company = {},
}) => {
    const currentIntercomSettings = {
        ...window.intercomSettings,
    };

    const newIntercomSettings = {
        custom_launcher_selector: '#my_custom_component',
        ...currentIntercomSettings,
        ...userInfo,
        hide_default_launcher: true,
        company: {
            ...currentIntercomSettings.company,
            ...company,
        },
    };

    window.intercomSettings = newIntercomSettings;
    integrateIntercom.intercomScript();
};


const integrateIntercom = (userInfo) => {
    if (integrateIntercom.integrated) return;
    integrateIntercom.integrated = true;

    const newUserInfo = {
        app_id: process.env.INTERCOM_APP_ID,
        name: userInfo.full_name,
        email: userInfo.email,
        user_id: userInfo.user,
        user_hash: userInfo.user_hash,
        phone: userInfo.phone,
        hide_default_launcher: false,
        avatar: {
            type: 'avatar',
            image_url: userInfo.user_img_path,
        },
    };

    const company = {
        company_id: userInfo.company.team_id,
        name: userInfo.company.name,
        size: userInfo.company?.employees,
        company_size: userInfo.company?.company_size,
        industry: userInfo.company?.section,
        user_count: userInfo.company?.members_count,
        plan: userInfo.company.plan?.description,
        ad_spend: userInfo.company.investment?.amount,
        ad_spend_currency: userInfo.company.investment?.currency,
        subscription_seats: userInfo.company.subscription_seats,
        used_seats: userInfo.company.used_seats,
        team_id: userInfo.company.team_id,
        billing_company_id: userInfo.company.id,
        ...formatAddonsToIntercom(userInfo.company.all_addons, userInfo.company.company_addons),
    };

    updateIntercomSettings({ userInfo: newUserInfo, company });
};

integrateIntercom.integrated = false;

/* eslint-disable */
  integrateIntercom.intercomScript = () => {
    // INTERCOM SCRIPT START
    (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            var d = document;
            var i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
                var s = d.createElement('script');
                s.onload = () => {
                    const event = new CustomEvent('onintercomloaded');
                    document.dispatchEvent(event);
                }
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/' + w.intercomSettings.app_id;
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') {
                l();
            } else if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();
    // INTERCOM SCRIPT END
  };
  /* eslint-enable */

export { integrateIntercom };
